import type { CategoryItem } from '@/scenes/Editor/components/FloatingInspectorButton/SharedComponents/CategoryHorizontalScroller'
import type {
  ClickableLabeledImageItem,
  SuggestionButtonPopover,
} from '@/scenes/Editor/components/EditWithAI/components/suggestedButtonSets'

export const BASIC_BACKGROUND_CATEGORY_ID = 'basic'

export const STUDIO_BACKGROUND_PRESETS: Array<{
  name: string
  prompt: string
  topHex: string
  bottomHex: string
}> = [
  { name: 'White', prompt: 'Clean light white, studio photoshoot lighting', topHex: '#F4F4F4', bottomHex: '#CDCDCD' },
  { name: 'Light Gray', prompt: 'Light gray (#D3D3D3), studio photoshoot lighting', topHex: '#D3D3D3', bottomHex: '#B5B5B5' },
  { name: 'Cool Gray', prompt: 'Cool gray (#8E949C), studio photoshoot lighting', topHex: '#8E949C', bottomHex: '#5C626A' },
  { name: 'Pale Taupe', prompt: 'Pale taupe (#E3D6CD), studio photoshoot lighting', topHex: '#E3D6CD', bottomHex: '#C2ACA4' },
  { name: 'Dusty Blush', prompt: 'Dusty blush (#DFCFC4), studio photoshoot lighting', topHex: '#DFCFC4', bottomHex: '#D38F7B' },
  { name: 'Warm Cream', prompt: 'Warm cream (#F0DDC7), studio photoshoot lighting', topHex: '#F0DDC7', bottomHex: '#F7C57B' },
  { name: 'Soft Rose', prompt: 'Soft rose (#F3DDD2), studio photoshoot lighting', topHex: '#F3DDD2', bottomHex: '#F1AFAE' },
  { name: 'Lilac', prompt: 'Lilac (#E0C0E1), studio photoshoot lighting', topHex: '#E0C0E1', bottomHex: '#C58FC4' },
  { name: 'Mint', prompt: 'Mint (#B8DCD2), studio photoshoot lighting', topHex: '#B8DCD2', bottomHex: '#88BFAF' },
  { name: 'Sky Blue', prompt: 'Sky blue (#B3D5E1), studio photoshoot lighting', topHex: '#B3D5E1', bottomHex: '#74B5CA' },
  { name: 'Lime Olive', prompt: 'Lime olive (#7C9800), studio photoshoot lighting', topHex: '#7C9800', bottomHex: '#0C1B00' },
  { name: 'Vivid Red', prompt: 'Vivid red (#C00000), studio photoshoot lighting', topHex: '#C00000', bottomHex: '#190100' },
  { name: 'Electric Violet', prompt: 'Electric violet (#A004A2), studio photoshoot lighting', topHex: '#A004A2', bottomHex: '#160016' },
  { name: 'Deep Teal', prompt: 'Deep teal (#0EA58D), studio photoshoot lighting', topHex: '#0EA58D', bottomHex: '#002926' },
  { name: 'Royal Blue', prompt: 'Royal blue (#1A2DFF), studio photoshoot lighting', topHex: '#1A2DFF', bottomHex: '#000028' },
]

type BackgroundGridPopoverParams = {
  title: string
  aspectRatio?: number | string
  items: ClickableLabeledImageItem[]
  categories: CategoryItem[]
}

export function createBackgroundGridPopover({
  title,
  aspectRatio,
  items,
  categories,
}: BackgroundGridPopoverParams): SuggestionButtonPopover {
  return {
    designType: 'grid',
    title,
    width: 320,
    maxHeight: 400,
    columns: 3,
    aspectRatio: aspectRatio ?? '1/1',
    items,
    categories,
  }
}
